import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ControlContainer, FormsModule, NgForm } from '@angular/forms';
import { makeCustomDecimalNumberMask } from '@app/functions';
import { TIME_WORKED, TimeOffType } from '@app/models/time-off-v3/time-off-type.model';
import { TimeOffIcons } from '@app/modules/time-off-v3/meta/time-off-meta';
import { TypesTooltips } from '@app/modules/time-off-v3/meta/tooltip-meta';
import { PlatformModule } from '@app/platform.module';
import { Locale, TranslatableKey } from '@app/types/translatable.type';
import { IconLabelsDisplayOptions } from '@app/types/translatables/icon-labels-display.options';
import { TranslateModule, TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'app-time-off-type-card',
    templateUrl: 'time-off-type-card.component.html',
    styleUrls: ['./time-off-type-card.component.scss'],
    standalone: true,
    imports: [CommonModule, PlatformModule, FormsModule, TranslateModule],
    viewProviders: [{ provide: ControlContainer, useExisting: NgForm }],
})
export class TimeTypeOffCardComponent {
    @Input() timeOffType = new TimeOffType();
    @Input() isUpdate = false;
    @Input() showHeaderInCard = false;
    @Output() onChange = new EventEmitter();

    typesToolTips = TypesTooltips;
    timeOffIcons = TimeOffIcons;
    timeWorkedOption = TIME_WORKED;

    numberMask = makeCustomDecimalNumberMask(this.translateService.currentLang as Locale);

    constructor(private translateService: TranslateService) {}

    getIconLabel(iconKey: string): TranslatableKey {
        return IconLabelsDisplayOptions[iconKey] ?? '';
    }
}
